<template>
    <div class="relative flex justify-center flex-grow text-white pb-5">
        <div @click="cm_visible = !cm_visible" class="self-end relative rounded-full bg-white aspect-square h-10">
            <span v-show="notification" class="absolute h-3 w-3 right-0 rounded-full bg-next-orange"></span>
        </div>
        <div v-if="cm_visible" class="absolute left-[87%] bottom-5 p-3 pr-10 bg-white cursor-pointer" style="box-shadow: 0 0 60px rgba(0,0,0,0.16)">
            <div class="text-next-neu flex flex-col text-left whitespace-nowrap cursor-pointer">
                <router-link v-if="hasPermission('access admin')" :to="{name:'HomePermessi'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Admin
                </router-link>
                <router-link :to="{name:'ProfiloUtente'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Profilo
                </router-link>
                <router-link :to="{name:'Configurazioni'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Configurazioni
                </router-link>

                <router-link v-if="me.responsabile_di_count > 0" :to="{name:'ControlloTimesheet'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Controllo timesheet
                </router-link>
                <router-link :to="{name:'Support'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Supporto
                </router-link>
                <router-link :to="{name:'DownloadCenter'}" @click.capture="cm_visible=false"
                             class="hover:text-next-dark-gray mb-2">Download center
                </router-link>
                <router-link :to="{name:'Logout'}" @click.capture="cm_visible=false"
                    class="hover:text-next-dark-gray font-bold">Logout
                </router-link>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from "vuex";

@Options({
    name:'ProfileMenuButton',
    props: {
        notification: Boolean
    },
    computed: {
        ...mapGetters([
            'me',
            'hasPermission',
        ])
    },
})
export default class ProfileMenuButton extends Vue {
    private cm_visible = false;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
